import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { PopupActions } from '../../../../../redux/actions';

import './styles.scss';

class ClosePopupButton extends React.Component {
  componentDidMount() {
    document.addEventListener('keyup', this.keyupEventListener, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.keyupEventListener, false);
  }

  keyupEventListener = ({ keyCode }) => {
    if (keyCode === 27) {
      this.closePopup();
    }
  };

  closePopup = () => {
    const {
      closePopupAction,
      closeCallBack,
      popupId,
    } = this.props;

    closePopupAction(popupId);
    closeCallBack();
  };

  render() {
    return (
      <div
        className='popup-close'
        onClick={this.closePopup}
      />
    );
  }
}

ClosePopupButton.defaultProps = {
  closeCallBack: () => {
  },
};

ClosePopupButton.propTypes = {
  popupId: PropTypes.string.isRequired,
  closeCallBack: PropTypes.func,
};

export default connect(
  () => ({}),
  (dispatch) => ({
    closePopupAction: (popupId) => {
      dispatch(PopupActions.closePopup(popupId));
    },
  }),
)(ClosePopupButton);
